import SERVICES_API_V1 from 'api/services/v1'
import { useCallback } from 'react'

export const useGetAccountLoginBulk = (networkId) => {
  const getAccountLogins = useCallback(
    (number) => {
      return SERVICES_API_V1.generateLoginBulk({
        params: { network_id: networkId, number },
      })
        .then(({ response: { data } }) => {
          return data.map((login) => {
            const { edit_type, prefix, postfix } = login

            switch (edit_type) {
              case 'fully_editable':
                return {
                  postfix: prefix + postfix,
                  prefix: '',
                  disabled: false,
                  loading: false,
                }
              case 'postfix_editable':
                return {
                  postfix: postfix,
                  prefix: prefix,
                  disabled: false,
                  loading: false,
                }
              case 'not_editable':
                return {
                  postfix: prefix + postfix,
                  prefix: '',
                  disabled: true,
                  loading: false,
                }
            }
          })
        })
        .catch(() => ({
          loading: false,
          disabled: true,
          postfix: '',
          prefix: '',
        }))
    },
    [networkId],
  )

  return { getAccountLogins }
}
